<div class="flex h-screen-safe bg-westetics-neutral-100">
  <!-- Overlay para fechar sidebar em mobile -->
  <div 
    *ngIf="isMobileSidebarOpen" 
    (click)="toggleMobileSidebar()"
    class="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
  ></div>

  <!-- Sidebar - escondido por padrão em mobile, visível em md+ -->
  <div 
    class="fixed md:relative z-50 md:z-auto transition-transform duration-300 md:translate-x-0"
    [ngClass]="isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'"
  >
    <app-sidebar-v2 (closeMobileSidebar)="closeMobileSidebar()"></app-sidebar-v2>
  </div>

  <!-- Conteúdo -->
  <main class="flex-1 min-w-0 flex flex-col w-full transition-all duration-300">
    <app-warning-modal></app-warning-modal>

    <!-- Tela pai /main/v2 -->
    <ng-container *ngIf="isMainV2">
      <!-- Botão hambúrguer para mobile -->
      <div class="md:hidden p-4">
        <button 
          (click)="toggleMobileSidebar()"
          class="p-2 rounded-lg hover:bg-westetics-neutral-200 transition-colors"
          aria-label="Abrir menu"
        >
          <svg class="w-6 h-6 text-westetics-neutral-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
      </div>
      <div class="flex flex-1 items-center justify-center p-4">
        <img
          src="assets/icons/Logo.png"
          alt="empty"
          class="w-full max-w-md lg:w-1/2 h-auto"
        />
      </div>
      <!-- Footer V2 - apenas na tela em branco -->
      <footer class="p-3 sm:p-4 safe-area-bottom">
        <div class="text-xs sm:text-sm text-westetics-neutral-600 text-center">
          © 2026 Westhetics. Todos os direitos reservados.
        </div>
      </footer>
    </ng-container>

    <!-- Header e conteúdo das filhas -->
    <ng-container *ngIf="!isMainV2">
      <!-- Header -->
      <app-header-v2 
        class="h-auto min-h-[5rem] sticky top-0 z-10"
        (openMobileSidebar)="toggleMobileSidebar()"
      ></app-header-v2>

      <!-- Conteúdo -->
      <section class="flex-1 p-3 sm:p-4 lg:p-6 overflow-auto safe-area-bottom">
        <router-outlet></router-outlet>
      </section>
    </ng-container>

  </main>
</div>
